import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import { OddsBoostEvents, PopularAccumulators, PopularBetBuilders } from '@swf/sports/features';
import useMarketUpdates from '@swf/sports/hooks/useMarketUpdates';

import styles from './SportsLandingPageWidget.scss';
import InPlayEvents from './components/InPlayEvents/InPlayEvents';
import LoadingState from './components/LoadingState/LoadingState';
import PopularCompetitions from './components/PopularCompetitions/PopularCompetitions';
import PopularEvents from './components/PopularEvents/PopularEvents';
import { sportsLandingPageWidgetModel, useSportsLandingPageWidget } from './model';

const WidgetContent = () => {
  const { widgetSelect, widgetDispatch } = useSportsLandingPageWidget();
  const hasPopularEvents = useSelector(widgetSelect.hasPopularEvents);
  const hasInPlayEvents = useSelector(widgetSelect.hasInPlayEvents);
  const hasPopularCompetitions = useSelector(widgetSelect.hasPopularCompetitions);
  const marketIds = useSelector(widgetSelect.marketIds);
  useMarketUpdates(marketIds, widgetDispatch.marketsUpdated);

  return (
    <>
      <PopularAccumulators widgetSelect={widgetSelect} />
      <PopularBetBuilders widgetSelect={widgetSelect} />
      <OddsBoostEvents widgetSelect={widgetSelect} />
      {hasPopularEvents ? <PopularEvents /> : null}
      {hasInPlayEvents ? <InPlayEvents /> : null}
      {hasPopularCompetitions ? <PopularCompetitions /> : null}
    </>
  );
};

const SportsLandingPageWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsLandingPageWidget();
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const hasErrored = useSelector(widgetSelect.hasErrored);

  if (isLoading && !hasPreloaded) {
    return <LoadingState />;
  }
  if (hasErrored) {
    return null;
  }

  return <WidgetContent />;
};

SportsLandingPageWidget.model = sportsLandingPageWidgetModel;

export default withWidgetTestId(SportsLandingPageWidget, 'sports-landing-page', {
  className: styles.wrapper
});
